import { Box, Grid, Typography } from '@mui/material';
import { DuplicateIcon } from 'components/SVG';
import { useFormikContext } from 'formik';
import React from 'react';
import {
  SparkDropdown,
  SparkFormToggleSwitch,
  SparkTextField,
} from 'sharedComponents/SparkForm';
import SparkIcon from 'components/SVG/SparkIcon';
import { DropdownOption } from 'types/common/DropdownOption';
import { SparkResourceSharePopoverValues } from './SparkResourceSharePopover';
import { useUpdateResourceShare } from 'hooks/share/useUpdateResourceShare';
import CopyToClipboardWrapper from '../CopyToClipboardWrapper';
import { useResourceAccessLevels } from 'hooks/share/useResourceAccessLevels';

type ShareableLinkSectionProps = {
  accessLevelDropdownOptions: DropdownOption[];
  resourceShareID: string | undefined;
  resourceTypeID: string;
};

function ShareableLinkSection({
  accessLevelDropdownOptions,
  resourceShareID,
  resourceTypeID,
}: ShareableLinkSectionProps) {
  const { values } = useFormikContext<SparkResourceSharePopoverValues>();
  const { getResourceAccessLevelID, isLoading: isLoadingResourceAccessLevels } =
    useResourceAccessLevels(resourceTypeID);
  const isActive = values.isActive;

  const {
    mutateAsync: updateResourceShare,
    isLoading: isUpdatingResourceShare,
  } = useUpdateResourceShare(resourceShareID);

  const handleChange = (checked: boolean) => {
    updateResourceShare({
      isActive: checked,
    });
  };

  const handleAccessLevelChange = (value: string | number) => {
    updateResourceShare({
      resourceAccessLevelID: getResourceAccessLevelID(
        resourceTypeID,
        value + ''
      ),
    });
  };
  const isLoading = isUpdatingResourceShare || isLoadingResourceAccessLevels;
  return (
    <Grid container padding={2} gap={1}>
      <Box
        width='100%'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
      >
        <Typography
          sx={{
            color: 'black',
            fontSize: '18px',
            fontFamily: 'Mont-SemiBold',
            paddingLeft: 2,
          }}
        >
          Shareable Link
        </Typography>
        <SparkFormToggleSwitch
          name='isActive'
          label={''}
          size={1}
          onChange={handleChange}
          isDisabled={isLoading}
        />
      </Box>
      {isActive && (
        <>
          <Grid
            container
            flexWrap='nowrap'
            gap={2}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              mt: 2,
            }}
          >
            <Grid item sx={{ display: 'flex', paddingLeft: 2, mt: 2 }} xs={12}>
              <SparkIcon />
              <Typography
                sx={{
                  color: 'black',
                  fontSize: '18px',
                  paddingLeft: 1,
                }}
              >
                Any Logged In User
              </Typography>
            </Grid>

            <SparkDropdown
              name='shareAbleLinkAccessLevel'
              label=''
              children={[...accessLevelDropdownOptions]}
              onChange={handleAccessLevelChange}
              menuItemProps={{ divider: false }}
              disabled={isLoading}
            />
          </Grid>
          <SparkTextField
            name='url'
            label=''
            readonly
            size={12}
            endAdornment={
              <CopyToClipboardWrapper textToCopy={values.url}>
                <Box
                  display='flex'
                  justifyContent='center'
                  alignItems='center'
                  gap={0.5}
                >
                  <DuplicateIcon />
                  <Typography
                    color={(theme) => theme.palette.primary.main}
                    variant='body2'
                    noWrap={true}
                  >
                    Copy Link
                  </Typography>
                </Box>
              </CopyToClipboardWrapper>
            }
            inputProps={{
              style: {
                textOverflow: 'ellipsis',
              },
            }}
          />
        </>
      )}
    </Grid>
  );
}

export default ShareableLinkSection;
